import { useState } from "react";
import { deleteDeposito, getDepositosPanel } from "../../services/DepositosServices";
import { DepositosContext } from "./DepositosContext"

export const DepositosState = ({ children }) => {

    const getDepositosPanelData = async (searchTerm, searchIDFilter, numPagina, filas) => {
        let res = await getDepositosPanel(searchTerm, searchIDFilter, numPagina, filas)
        return res
    }

    const deleteDepositoData = async (body) => {
        const res = await deleteDeposito(body)
        if (res) getDepositosPanelData()
        return res
    }


    return <DepositosContext.Provider value={{
        deleteDepositoData,
        getDepositosPanelData,
    }} >
        {children}
    </DepositosContext.Provider>
}